import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { PersonalDataEditorComponent } from '../../../user/components/personal-data-editor/personal-data-editor.component';
import { PatrolUserService } from '../../../user/service/patrol-user.service';

@Component({
  selector: 'app-patrol-profile',
  standalone: true,
  imports: [CommonModule, TranslatePipe, PersonalDataEditorComponent],
  templateUrl: './patrol-profile.component.html',
  styleUrl: './patrol-profile.component.scss',
})
export class PatrolProfileComponent {
  readonly #patrolUserService = inject(PatrolUserService);

  readonly patrolUser = this.#patrolUserService.patrolUser;
}
